import { render, staticRenderFns } from "./CiFarbenV25.vue?vue&type=template&id=f535f1e4&scoped=true"
import script from "./CiFarbenV25.vue?vue&type=script&lang=js"
export * from "./CiFarbenV25.vue?vue&type=script&lang=js"
import style0 from "./CiFarbenV25.vue?vue&type=style&index=0&id=f535f1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535f1e4",
  null
  
)

export default component.exports